import { useRoute, useRouter } from '@nuxtjs/composition-api'
import { Dictionary, equals } from 'ramda'
import { Location } from 'vue-router'
import { combineQuery, QueryAction } from '~/lib/utilities'

export const useRouteSetting = () => {
  const route = useRoute()
  const router = useRouter()

  const setRouteQuery = (
    newQuery: Dictionary<string | (string | null)[]>,
    keepingRouterHistory: boolean = true
  ) => {
    const queryEqual = equals(newQuery, route.value.query)
    if (queryEqual) return false

    const appendedRoute: Location = {
      query: newQuery,
      hash: route.value.hash,
    }
    if (keepingRouterHistory) {
      router.push({ path: route.value.path, ...appendedRoute })
    } else {
      router.replace(appendedRoute)
    }
    return true
  }

  const combineCurrentQuery = (queryActions: QueryAction | QueryAction[]) => {
    return combineQuery(route.value.query, queryActions)
  }

  return {
    setRouteQuery,
    combineCurrentQuery,
  }
}
